import { render, staticRenderFns } from "./SalaryPanel.vue?vue&type=template&id=27cea2d0"
import script from "./SalaryPanel.vue?vue&type=script&lang=js"
export * from "./SalaryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports